import {AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {RSDialogComponentModel} from '../../../libs/rsnotify/rsdialog.component.model';
import {
  ExtensionActivityType,
  ExtensionCategory,
  ExtensionEvent,
  Hort360PropertySummary
} from '../../../../functions/src/types';
import {RSDialog} from '../../../libs/rsnotify/rsdialog';
import {UserService} from '../../services/user.service';
import {RSValidatorFormDirective} from '../../../libs/rsvalidator/rsvalidator.directive';
import {AvailableIcon, IconsService} from '../../services/icons.service';
import {DataService} from '../../services/data.service';
import invert from 'invert-color';
import {PropertyService} from '../../services/property.service';
import {RSDialogService} from '../../../libs/rsnotify/rsdialog.service';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import * as moment from 'moment';
import {MatTab, MatTabGroup} from '@angular/material/tabs';
import {Moment} from 'moment';
import {ReplaySubject} from "rxjs";
import {map} from "rxjs/operators";

@Component({
  selector: 'app-add-event',
  templateUrl: './add-event.component.html',
  styleUrls: ['./add-event.component.scss']
})
export class AddEventComponent extends RSDialogComponentModel implements OnInit, AfterViewInit, OnDestroy {
  event: ExtensionEvent = {} as ExtensionEvent;
  @ViewChild('actionButtons', {static: true, read: TemplateRef}) actionButtons: TemplateRef<any>;
  @ViewChild('form') inputForm: RSValidatorFormDirective;
  @ViewChild('formAttendees') inputFormAttendees: RSValidatorFormDirective;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;

  public selectedProperties: Hort360PropertySummary[] = [];
  public propertyAttendees: {[key: number]: number} = {};

  filteredCategories = new ReplaySubject<ExtensionCategory[]>(1);


  constructor(
    private userService: UserService,
    public dataService: DataService,
    public rsDialogService: RSDialogService,
    public propertyService: PropertyService,
    private fbDB: AngularFirestore
  ) {
    super();

    // Wait for input
    this.dialogValuesUpdated.subscribe(v => {
      this.updateEvent(v.event);
    });
    this.updateEvent({});
  }

  invertColor(hex) {
    return invert(hex || '#ffffff', true);
  }

  ngOnInit(): void {
    this.dataService.categories.pipe(
      map(categories => {
        // Get all non-archived categories
        const activeCategories = categories.filter(cat => !cat.archived);

        // If we have a selected category that's archived, add it to the list
        if (this.event.category) {
          const selectedCategory = categories.find(cat =>
            cat.id === this.event.category && cat.archived);
          if (selectedCategory) {
            activeCategories.push(selectedCategory);
          }
        }

        return activeCategories;
      })
    ).subscribe(filtered => {
      this.filteredCategories.next(filtered);
    });

  }

  ngOnDestroy() {  }

  ngAfterViewInit(): void {
    this.dialogHandles.buttonTemplateRef = this.actionButtons;
    this.dialogHandles.buttonTemplateAttach();
  }

  public setDate(date: Date | Moment) {
    this.event.date = +moment(date).format('X');
  }

  async updateEvent(input: any) {
    if (!input) {
      input = {};
    }
    this.event = {
      id: input.id || null,
      name: input.name || null,
      date: input.date || moment().format('X'),
      category: input.category || null,
      notes: input.notes || null,
      locationTown: input.locationTown || null,
      locationLga: input.locationLga || null,
      totalAttendees: input.totalAttendees || 0,
    } as ExtensionEvent;

    // Do we need to load properties?
    if (this.event.id) {
      this.propertyAttendees = {};
      const attendees = await this.fbDB.collection(`events/${this.event.id}/attendees`).get().toPromise();
      const propertyIds = attendees.docs.map(d => d.id + '');
      attendees.docs.forEach(d => this.propertyAttendees[d.id] = (d.data() || {} as any).total || 1);
      this.selectedProperties = this.propertyService.getPropertySummaries(propertyIds);
    }

    // Done!
    console.log('updateEvent::: ', this.event, this.selectedProperties, this.propertyAttendees);
  }

  close() {
    this.dialogHandles.close(RSDialog.defaultValues.CANCEL);
  }

  updatePropertyAttendee(property: Hort360PropertySummary, total: number) {
    this.propertyAttendees[property.id] += total;
    if (this.propertyAttendees[property.id] < 0) {
      this.propertyAttendees[property.id] = 0;
    }
  }

  async selectProperty(property: Hort360PropertySummary) {
    const index = this.selectedProperties.findIndex(p => p.id === property.id);
    if (index !== -1) {
      // ARE YOU SURE?
      const bSure = await this.rsDialogService.showConfirmDialog(
                        `Are you sure you want to remove '${property.name}' from this event?`, false, 'Remove', RSDialog.Style.WARN);
      if (bSure) {
        this.selectedProperties.splice(index, 1);
        delete this.propertyAttendees[property.id];
      }
    } else {
      this.selectedProperties.push(property);
      this.propertyAttendees[property.id] = 1;
    }
  }

  nextTab() {
    if (!this.inputForm.isValid(true)) {
      return;
    } else {
      this.tabGroup.selectedIndex = 1;
    }
  }

  saveEvent() {
    if (!this.inputForm.isValid(true)) {
      this.tabGroup.selectedIndex = 0;
      return;
    } else if (!this.inputFormAttendees.isValid(true)){
      this.tabGroup.selectedIndex = 1;
      return;
    }
    else {
      this.dialogValues.event = this.event;
      this.dialogValues.propertyAttendees = this.propertyAttendees;
      this.dialogHandles.close(RSDialog.defaultValues.YES);
    }
  }

}
